import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import appSelectors from '@/redux/app/appSelectors';
import authSelectors from '@/redux/auth/authSelectors';
import userSelectors from './redux/user/userSelectors';

import appOperations from '@/redux/app/appOperations';
import userOperations from '@/redux/user/userOperations';
import analyticOperations from './redux/analytics/analyticOperations';

import useWindowSize from '@/hooks/useWindowSize';
import useBlockScroll from '@/hooks/useBlockScroll';
import useTranslation from '@/hooks/useTranslation';
// import useRefreshToken from '@/hooks/useRefreshToken';

import Router from '@/router';
import RouteNames from '@/router/routes';

import ModalSupportRequired from '@/components/modalSupportRequired';

import '@/css/reset.css';
import '@/css/variables.css';
import '@/css/index.css';
import '@/css/buttons.css';

const SUPPORT_ROUTE = `/${RouteNames.SUPPORT}`;

function App() {
  const dispatch = useDispatch();

  const isAuth = useSelector(authSelectors.isAuthorized);
  const i18n = useSelector(appSelectors.translation);
  const userStatus = useSelector(userSelectors.status);
  const userId = useSelector(userSelectors.id);

  const { pathname } = useLocation();

  const [displayPopupSupport, setDisplayPopupSupport] = useState(false);
  const hidePopupSupport = () => setDisplayPopupSupport(false);

  useEffect(() => {
    dispatch(appOperations.getLanguages());
  }, [dispatch]);

  useEffect(() => {
    if (isAuth) dispatch(userOperations.getUser());
  }, [dispatch, isAuth]);

  useEffect(() => {
    if (isAuth && userId) analyticOperations.sendGAClientId(userId);
  }, [dispatch, isAuth, userId]);

  useEffect(() => {
    if (
      userStatus === 'financial_profile_block' &&
      !pathname.includes(SUPPORT_ROUTE)
    ) {
      setDisplayPopupSupport(true);
    }
  }, [pathname, userStatus]);

  useWindowSize();
  useBlockScroll();
  useTranslation();
  // useRefreshToken();

  return (
    i18n && (
      <>
        <Router />
        {displayPopupSupport && (
          <ModalSupportRequired closeModal={hidePopupSupport} />
        )}
      </>
    )
  );
}

export default App;
